import type { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

let enqueueSnackbarRef: (msg: SnackbarMessage, options?: OptionsObject) => SnackbarKey;
let closeSnackbarRef: (key: SnackbarKey) => void;

export const SnackbarUtils = {
  setSnackbarFuncs: (enqueue: typeof enqueueSnackbarRef, close: typeof closeSnackbarRef) => {
    enqueueSnackbarRef = enqueue;
    closeSnackbarRef = close;
  },
  enqueue: (msg: SnackbarMessage, options?: OptionsObject) => {
    if (enqueueSnackbarRef) {
      return enqueueSnackbarRef(msg, options);
    }
    console.warn('enqueueSnackbarRef not set');
  },
  close: (key: SnackbarKey) => {
    if (closeSnackbarRef) {
      closeSnackbarRef(key);
    }
  },
};
